import {Diagram} from "platformed-client/types";
import {procureToPay} from "./procureToPay";
import {orderToCash} from "./orderToCash";
import {itAccessProvisioning} from "./itAccessProvisioning";
import {icfrArchitecture} from "./icfrArchitecture";
import {governanceStructure} from "./governanceStructure";

export {procureToPay} from "./procureToPay";
export {orderToCash} from "./orderToCash";
export {itAccessProvisioning} from "./itAccessProvisioning";
export {icfrArchitecture} from "./icfrArchitecture";
export {governanceStructure} from "./governanceStructure";
export {DIAGRAM_SWIMLANES} from "./swimlanes";
export {DIAGRAM_AI_GENERATIONS} from "./aiGenerations";
export {DIAGRAM_NODE_CITATIONS} from "./citations";

export const HARDCODED_DIAGRAMS: Diagram[] = [
  procureToPay,
  orderToCash,
  itAccessProvisioning,
  icfrArchitecture,
  governanceStructure,
];
